import { Injectable } from '@angular/core';
import { NewsDetails } from '../models/news-details';
import { CoreHttpClient } from '@core-modules/providers/core-http-client/core-http-client';
import { EnvironmentProvider } from '@core-modules/providers/environment-variables/environment';


@Injectable()
export class NewsProvider
{

    //#region Constructor

    /**
     * Class constructor
     * @param {CoreHttpClient} private http
     * @param {EnvironmentProvider} private environment
     */
    constructor
    (
        private http: CoreHttpClient,
        private environment: EnvironmentProvider)
    {

    }

    //#endregion


    //#region Methods

    /**
     * Load the news items
     */
    public async getNewsItems(): Promise<NewsDetails[]>
    {
        let requestUrl: string = `${this.environment.apiEndpoint}/mobileapp/News/GetNewsItems`;
        
        let array = await this.http.get<NewsDetails[]>(requestUrl);

        return array;
    }

    //#endregion
}
